import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollHandler = () => {
      this.element.classList.toggle('scrolled', window.scrollY > 50)
    }
    window.addEventListener('scroll', this.scrollHandler)
  }

  disconnect() {
    window.removeEventListener('scroll', this.scrollHandler)
  }

  toggle() {
    const btn = this.element.querySelector('.nav-toggle') || this.element.querySelector('.nav-hamburger')
    if (!btn) return
    const expanded = btn.getAttribute('aria-expanded') === 'false' ? 'true' : 'false'
    btn.setAttribute('aria-expanded', expanded)
    btn.classList.toggle('active')
    const menu = this.element.querySelector('ul') || this.element.querySelector('.nav-links')
    if (menu) menu.classList.toggle('open')
  }

  smoothScroll(event) {
    const href = event.currentTarget.getAttribute('href')
    if (!href || href === '#') return
    event.preventDefault()
    const target = document.querySelector(href)
    if (target) target.scrollIntoView({ behavior: 'smooth' })
    this.element.querySelector('ul').classList.remove('open')
  }
}
